import React from "react";
import clsx from "clsx";
import { useBreakpoint } from "../../../shared/utils/hooks/useBreakpoint";

type socialMediaInfo = {
  label: string;
  href: string;
};

const socialList: socialMediaInfo[] = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/hereweare_official/",
  },
  {
    label: "YouTube",
    href: "https://youtube.com/@hereweare_official?si=sgZ0BUYGeMlnl4M5",
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/people/Hereweare/61564038441136/",
  },
  {
    label: "Spotify",
    href: "https://open.spotify.com/show/69lQigFVQxdcyQlVxyh4uI?si=D0zBAe2gR9eyvKYRf5J0hA",
  },
  {
    label: "Apple Podcasts",
    href: "https://podcasts.apple.com/kr/podcast/hereweare/id1822206336?i=1000714137011",
  },
];

export default function Footer() {
  const { desktopMode } = useBreakpoint();

  const contactEmail = "support@hereweare.io";
  const sendEmail = () => {
    window.location.href = `mailto:${contactEmail}`;
  };

  return (
    <div
      id="footer"
      className="white-cursor bg-black text-white py-8 text-sm max-w-full px-0 sm:py-12 font-arial"
    >
      <div className="flex flex-col gap-[3rem] sm:gap-[5rem] lg:gap-[10rem]">
        <div className="flex flex-col px-2 sm:px-4 lg:px-10 gap-[2.5rem] sm:gap-[1.5rem] lg:gap-[2rem]">
          <div
            className={clsx(
              "flex flex-col gap-[1.5rem] text-[0.875rem] leading-[1.375rem]",
              "sm:flex-row sm:gap-[2.5rem] sm:text-[1rem] sm:leading-[1.625rem]",
              "lg:text-[1.25rem] lg:leading-[1.875rem]"
            )}
          >
            <a
              href="https://static.hereweare.io/html/terms_en.html"
              target="_blank"
            >
              HereWeAre TERMS OF USE
            </a>
            <a
              href="https://static.hereweare.io/html/privacy_policy_en.html"
              target="_blank"
            >
              PRIVACY POLICY
            </a>
          </div>

          <div
            className={clsx(
              "flex flex-col lg:flex-row gap-[2.5rem] text-[0.875rem] leading-[1.375rem]",
              "sm:gap-[2rem] sm:text-[1rem] sm:leading-[1.625rem]",
              "lg:gap-[5rem] lg:text-[1.25rem] lg:leading-[1.875rem]"
            )}
          >
            <div className="flex-1 space-y-[0.37rem]">
              <p className="text-[#999]">Address</p>
              <p>
                8, Beongae-ro 331beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do,
                Republic of Korea
              </p>
            </div>
            <div className="flex-1 space-y-[0.37rem]">
              <p className="text-[#999]">Contact</p>
              <p onClick={sendEmail}>{contactEmail}</p>
            </div>
            <div className="flex-1 space-y-[0.37rem]">
              <p className="text-[#999]">Social Media</p>
              <div className="flex flex-col space-y-[0.62rem]">
                {socialList.map((socialInfo) => (
                  <a key={socialInfo.label} href={socialInfo.href} target="_blank">
                    {socialInfo.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-[1.5rem] sm:space-y-[2.5rem]">
          <img src="/assets/img/hereweare-logo-white.svg" className="w-full" />
          <div
            className={clsx(
              "flex gap-4 px-[0.75rem]",
              "sm:px-[0.5rem]",
              "lg:px-[1rem]"
            )}
          >
            <div
              className={clsx(
                "flex-1 flex flex-col gap-[0.5rem] text-[0.75rem] leading-[1.125rem]",
                "sm:text-[0.875rem] sm:leading-[1.5rem]",
                "lg:flex-row lg:text-[1rem] lg:leading-[1.625rem] lg:items-center"
              )}
            >
              <div className="flex-1 content-center">
                © HWA COM CO., LTD. All rights reserved.
              </div>
              {desktopMode && (
                <div className="flex-1 justify-items-end">{moveTopBtn()}</div>
              )}
            </div>

            {!desktopMode && moveTopBtn()}
          </div>
        </div>
      </div>
    </div>
  );
}

function moveTopBtn() {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className="grid animate-updownMoveTop size-[3rem] sm:size-16 rounded-full bg-[#191919] content-center justify-items-center cursor-pointer"
      onClick={scrollTop}
    >
      <img
        className="size-[1.5rem] sm:size-8"
        src="/assets/img/top-arrow.svg"
      />
    </div>
  );
}
